module.exports = {
    APP_ENV: 'production',
    API_URL: '/api'
};


// WEBPACK FOOTER //
// ./src/env/production.js